import {createReducer} from '@reduxjs/toolkit';

import {DEFAULT_OVERLAYS, DEFAULT_ZOOM, TOURS} from '../constants/index.js';
import {OVERLAYS} from '@explorer/components/map/layer-tools';
import {
  changeMapView,
  clearMapPin,
  fitExtent,
  pinMap,
  resetMap,
  setDrawTool,
  setMeasureMode,
  setOverlayOn,
  setUserOverlayUrl,
} from '../actions/map.js';
import {executeSearch} from '@explorer/actions/search';
import {resetTour, setTour} from '../actions/tour.js';

export const initialMapView = {
  /**
   * The map center.
   * @type {Array<number>}
   */
  center: [0, 0],
  /**
   * The map zoom level.
   * @type {number}
   */
  zoom: DEFAULT_ZOOM,
  /**
   * A hint to change extent to the map.
   * @type {Array<number>}
   */
  fitExtent: [],
};

export const initialState = {
  ...initialMapView,
  /**
   * The coordinate of a map pin
   * @type {Array<number>}
   */
  mapPin: null,

  drawTool: {
    name: '',
    layer: '',
    target: '',
  },

  /**
   * Whether to show an overlay layer.
   * @type {Boolean}
   */
  overlays: {...DEFAULT_OVERLAYS},

  userOverlayUrl: '',

  measuring: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(changeMapView, (state, {payload: view}) => {
    state.center = view.center ? view.center : state.center;
    state.zoom = view.zoom ? view.zoom : state.zoom;
  });

  builder.addCase(pinMap, (state, {payload}) => {
    state.mapPin = payload.coordinate;
  });

  builder.addCase(clearMapPin, state => {
    state.mapPin = initialState.mapPin;
  });

  builder.addCase(fitExtent, (state, {payload}) => {
    state.fitExtent = payload;
  });

  builder.addCase(setDrawTool, (state, {payload}) => {
    state.drawTool = {...state.drawTool, ...payload};
  });

  builder.addCase(setOverlayOn, (state, {payload}) => {
    state.overlays[payload.name] = payload.on;
  });

  builder.addCase(setUserOverlayUrl, (state, {payload}) => {
    state.userOverlayUrl = payload;
  });

  builder.addCase(resetMap, state => ({
    ...state,
    ...initialMapView,
  }));

  builder.addCase(setMeasureMode, (state, {payload}) => {
    state.measuring = !!payload;
  });

  builder.addCase(setTour, (state, {payload}) => {
    if (payload !== TOURS.OVERZOOM) {
      return initialState;
    }
    return state;
  });

  builder.addCase(resetTour, (state, {payload}) => {
    if (payload !== TOURS.OVERZOOM) {
      return initialState;
    }
    return state;
  });

  builder.addCase(executeSearch, (state, {payload: suggestion}) => {
    if (suggestion) {
      state.overlays[OVERLAYS.CENTER_MARKER] =
        !!suggestion.showCenterMarker || state.overlays[OVERLAYS.CENTER_MARKER];
    }
  });
});
